function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { TOUR_DONE_MODAL } from '../../../../../components/modal/TourDoneModal';
import { showModal } from '../../../../../redux/actions';
import { TOGGLE_RIGHT_MENU_VISIBILITY } from '../../../../../redux/constants/layout';
import text from '../../../../../text';
import { store } from '../../../../../utilities/store';
import { StepContent } from './TourContent';
import { hightlightedAreaStyling, popoverCustomDefaultStyling } from './config';
var isOverflown = function(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};
export var TOUR_2D_MAP = [
    {
        selector: '#pac-input',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour2dStep1Title'),
                description: text('tour2dStep1')
            });
        },
        position: 'bottom',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginTop: '16px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'top'
        }
    },
    {
        selector: '.draw-menu',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour2dStep2Title'),
                description: text('tour2dStep2')
            });
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '16px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.ProductControls',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour2dStep3Title'),
                description: text('tour2dStep3')
            });
        },
        position: 'left',
        styles: {
            popover: function(base) {
                var _popoverCustomDefaultStyling = popoverCustomDefaultStyling(base), top = _popoverCustomDefaultStyling.top, rest = _object_without_properties(_popoverCustomDefaultStyling, [
                    "top"
                ]);
                var _isOverFlown = isOverflown(document.querySelector('.ProductControls'));
                var marginLeft = _isOverFlown ? '106px' : '98px';
                var clientTop = document.querySelector('.ProductControls').getBoundingClientRect().top;
                return _object_spread_props(_object_spread({}, rest), {
                    marginLeft: marginLeft,
                    top: "".concat(clientTop - 154, "px")
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.wrapper',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour2dStep4Title'),
                description: text('tour2dStep4')
            });
        },
        position: 'left',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '-20px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'right',
            caretPosY: 'xs',
            callback: {
                next: function() {
                    store.dispatch({
                        type: TOGGLE_RIGHT_MENU_VISIBILITY,
                        payload: true
                    });
                }
            },
            stepDelay: 300
        }
    },
    {
        selector: '.RightMenuV2',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour2dStep5Title'),
                description: ''
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-3"
            }, text('tour2dStep5_1')), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3"
            }, text('tour2dStep5_2')), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, text('tour2dStep5_3')));
        },
        position: 'left',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '-20px',
                    maxWidth: '30%',
                    top: "-30%"
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'right',
            callback: {
                next: function() {
                    store.dispatch(showModal(TOUR_DONE_MODAL));
                }
            }
        }
    }
];
